import React, { useState } from 'react';
import WatchSelection from './WatchSelection';
import BroadcastViewer from './BroadcastViewer';

/**
 * WatchPage - top-level route component for /watch
 *
 * Manages two views:
 *   selection  → WatchSelection (event/run picker)
 *   viewing    → BroadcastViewer (synchronized player)
 */
function WatchPage() {
  const [view, setView] = useState('selection'); // 'selection' | 'viewing'
  const [videoDataArray, setVideoDataArray] = useState([]);
  const [eventLabel, setEventLabel] = useState('');

  const handleLaunch = (videos, label) => {
    setVideoDataArray(videos);
    setEventLabel(label);
    setView('viewing');
  };

  const handleBack = () => {
    setView('selection');
    setVideoDataArray([]);
    setEventLabel('');
  };

  if (view === 'viewing') {
    return (
      <BroadcastViewer
        videoDataArray={videoDataArray}
        eventLabel={eventLabel}
        onBack={handleBack}
      />
    );
  }

  return <WatchSelection onLaunch={handleLaunch} />;
}

export { WatchPage };
export default WatchPage;
